import { useNavigate } from 'react-router-dom';

export { useGTM } from './google/useGTM';
export { useAuthToken } from './gql/useAuthToken';
export { useEffectOnce } from './useEffectOnce';
export { useIsPermitted } from './useIsPermitted';
export { useIsAdmin } from './useIsAdmin';
export { useCacheBustedSrc, useCacheBustedSrcs } from './useCacheBustedSrc';
export { useImagePreview, useImagePreviewState } from './useImagePreviewState';
export { useAppSearchParams } from './useAppSearchParams';
export { useCurrentTeam } from './team/useCurrentTeam';
export { useShopifyOAuthConnect } from './team/useShopifyOAuthConnect';
export { useProjectConnector } from './project/useProjectConnector';
export { useCurrentProject } from './project/useCurrentProject';
export { useProjectSettingsNavigate } from './project/useProjectSettingsNavigate';
export type { ProjectSettingsLocationState } from './project/useProjectSettingsNavigate';
export {
  useFacebookAds,
  LINKED_ADS_FILTER,
  ALL_ADS_PAGINATE,
} from './project/useFacebookAds';
export {
  useProjectObjectWithStats,
  DEFAULT_STATISTICS,
  getStatistics,
} from './project/useProjectObjectWithStats';
export { useBillingPortal } from './payment/useBillingPortal';
export { useProfile } from './useProfile';
export { useUTMParams } from './useUTMParams';

export const useAppNavigate = useNavigate;
